var _rect, _g, _rect2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBeneficiosMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 663,
    viewBox: "0 0 350 663",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 663
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 663,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_175)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_131_175)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 663,
    rx: 20,
    fill: "#1F375B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_131_175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 663
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 663,
    rx: 20,
    fill: "#1F375B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_131_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2924 26.8525C36.5571 19.7072 40.0762 10.0241 40.0775 -0.072048C40.0788 -10.1682 36.5622 -19.8525 30.2994 -27L26.0843 -22.201C31.078 -16.2951 33.8372 -8.39441 33.7687 -0.196973C33.7003 8.00047 30.8097 15.8401 25.7184 21.6368C20.6271 27.4336 13.7414 30.7246 6.54149 30.8025C-0.658425 30.8804 -7.59782 27.7391 -12.785 22.0536L-17 26.8526C-10.7235 33.9817 -2.21966 37.9854 6.64617 37.9854C15.512 37.9854 24.0159 33.9817 30.2924 26.8525Z",
    fill: "url(#paint0_linear_131_175)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_131_175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 337.5,
    r: 124.5,
    fill: "url(#paint1_linear_131_175)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.262 632.137C335.624 627.966 343.18 626.837 350.272 628.999C357.364 631.161 363.414 636.437 367.094 643.671L372.295 640.251C367.745 631.625 360.4 625.378 351.844 622.857C343.287 620.337 334.203 621.744 326.549 626.775C318.894 631.807 313.282 640.06 310.921 649.757C308.56 659.455 309.639 669.82 313.926 678.62L319.127 675.201C315.464 667.958 314.473 659.356 316.373 651.283C318.273 643.21 322.909 636.324 329.262 632.137V632.137Z",
    fill: "url(#paint2_linear_131_175)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_131_175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 1091,
    r: 243,
    fill: "url(#paint3_linear_131_175)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_131_175",
    x: -84,
    y: -66,
    width: 518,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_131_175"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.780392 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_175"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_131_175"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.780392 0 0 0 0 0.972549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_131_175",
    result: "effect2_dropShadow_131_175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_131_175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_131_175",
    x: -406,
    y: -421,
    width: 1517,
    height: 1517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 317,
    result: "effect1_foregroundBlur_131_175"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_131_175",
    x: -798,
    y: 214,
    width: 1754,
    height: 1754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 317,
    result: "effect1_foregroundBlur_131_175"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_175",
    x1: 18.1601,
    y1: -159.644,
    x2: 5.97324,
    y2: 86.6383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_131_175",
    x1: -46.7025,
    y1: 1139.32,
    x2: 857.402,
    y2: 724.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_131_175",
    x1: 358.824,
    y1: 582.002,
    x2: 276.001,
    y2: 812.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_131_175",
    x1: -700.166,
    y1: 2655.99,
    x2: 1064.47,
    y2: 1847.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBeneficiosMobile);
export default __webpack_public_path__ + "static/media/back-beneficios-mobile.4543b948dbc54a00451daa0c3e3827a5.svg";
export { ForwardRef as ReactComponent };